import React, { Component } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import {getPageUrl} from '../lib/helpers'

import Container from '../components/container'
import BlogPostInfinite from '../components/blog-post-infinite'
//import fetch from "node-fetch";



class LoadMore extends Component {
  constructor(props) {
    super(props);
    // initialize state
    // add if any nextArticles provided to initialize the next page for infinite scroll
    if (props.nextArticles)
        this.state = {
            nextArticleSlugs: props.nextArticles
        };
    else
        this.state = {
            nextArticleSlugs: []
        };
    // initialize other params
    this.state['articles'] = []
    this.state['search_index'] = props.search_index

    // convert slugs to articles
    this.getArticleFromSlug(this.state.nextArticleSlugs)

    this.fetchUserData()

    // pass through parameters
    this.location = location.pathname
    this.state['persona'] = {
        "pca1":0,
        "pca2":0,
        "pca3":0,
    }

  };

  fetchUserData=()=>{
      //creating function to load ip address from the API
    let self = this; // Reference to this
    fetch('https://geolocation-db.com/json/')
        .then(function(response){
            return response.json();
        })
        .then(function(myJson) {
            self.setState({
                userIP: myJson
            });
          });
  }


  getArticleFromSlug = (listOfSlugs) => {
    // pushes list of slugs into articles to display
    let self = this; // Reference to this

    let i = 0;
    let len = listOfSlugs.length;
    for (; i<len; ){

        //let slug = listOfSlugs[i]['path']

        fetch('/page-data'+getPageUrl(listOfSlugs[i])+'page-data.json'
        ,{
          headers : {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            return response.json();
          })
          .then(function(myJson) {
            if ( ('result' in myJson) ){
              self.setState({
                articles: self.state.articles.concat(myJson['result']['data']['strapi']['page'])
              });
            }
          });

        i++;
    }
    
    self.nextArticleSlugs = []
  };
  

  fetchData=()=>{
    
    let self = this; // Reference to this

    // get list of next slugs
    fetch(`https://us-central1-hosting-for-digital-projects.cloudfunctions.net/content_recommendation_v1?sid=${process.env.GATSBY_SITE_ID}&pid=${process.env.GATSBY_PROJECT_ID}&page=${self.location}`
    ,{
      method: 'POST',
      headers : {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       },
      body : JSON.stringify({
          'page': self.location,
          'source': self.state.userIP,
          'persona': self.state.persona,
          'journey': self.state.journey
      })
    }
    )
      .then(function(response){
        return response.json();
      })
      .then(function(myJson) {
        self.getArticleFromSlug(myJson['recommendations']);
      });
  };
  


  
  render() {
    
    return (
      <>
        <InfiniteScroll
                dataLength={this.state.articles.length}
                next={this.fetchData}
                hasMore={true}
                loader={<Container></Container>}
            >
                {this.state.articles.map((i, index) => (
                    <span key={`${i.id}_${index}`}>
                        <BlogPostInfinite article={i} search_index={this.state.search_index} page_number={index}/>
                    </span>
                ))}
        </InfiniteScroll>
      </>
    );
  }
}


export default LoadMore;